import { Button, Icon24ArrowRight, Typography } from "@cur8/maneki";
import { useClearRoomControllerMutation } from "hooks/mutations/useClearRoomControllerMutation";
import { useCallback } from "react";
import { paths } from "render/routes/paths";
import { InformationLayout } from "render/ui/layout/InformationLayout/InformationLayout";
import { PageFrameContent } from "render/ui/layout/PageFrameContent/PageFrameContent";

type CheckOutViewProps = {
  goTo(url: string): void;
  patientId: string;
  visitId: string;
};

export function CheckOutView({ goTo, patientId, visitId }: CheckOutViewProps) {
  const { mutate: clearRoomController } = useClearRoomControllerMutation();

  const handleContinue = useCallback(() => {
    clearRoomController(
      { patientId, visitId },
      { onSuccess: () => goTo(paths.root.url({})) }
    );
  }, [clearRoomController, goTo, patientId, visitId]);

  return (
    <PageFrameContent>
      <InformationLayout
        content={
          <>
            <Typography variant="display-s">Ready to check-out?</Typography>
            <Typography variant="body-m" color="subtle">
              Check out if all examinations are complete
            </Typography>
          </>
        }
        buttons={
          <Button
            onPress={handleContinue}
            fillContainer
            icon={<Icon24ArrowRight />}
          >
            Check-out
          </Button>
        }
      />
    </PageFrameContent>
  );
}
